export default __webpack_public_path__ + "static/media/mastercard-logo.da5d4fb5.png";